<template>
  <CollapsePanel
    :title="$t('route_management.object_children')"
    :loading=loading
    :showCount=true
    :count="pagination.total"
    :showCollapseAction="$can('create', 'mapobject')"
    @collapseAction="toggleShowCollapseMenu"
    :icon="showCollapseMenu ? 'times' : 'plus'"
    panelName="drawing.children"
    :borderTop="false"
  >
    <template v-slot:customCollapseAction v-if="showCollapseMenu">
      <CollapseActionMenu>
        <CollapseActionMenuItem
          v-for="item in formatTypesWithHeaderAsMenuItems"
          :key="item.key"
          :title="item.title"
          :icon="item.icon"
          :clickable="item.clickable"
          @clickItem="item.clickable ? toCreateMapObject(item.key) : null"
        />
      </CollapseActionMenu>
    </template>
    <div class="map-objects-list">
      <ChildObject v-for="(child, key) in children"
                   :key="key"
                   :child="child"
                   @goToObject="goToObject"
      />
    <Pagination
      @switchPage="switchPage"
      :total="pagination.total"
      :count="pagination.count"
      :per_page="pagination.per_page"
      :current_page="pagination.current_page"
      :total_pages="pagination.total_pages"  />
    </div>
  </CollapsePanel>
</template>

<script>
import { mapGetters } from 'vuex';

import EventBus from '@/events/event-bus';

import NetworkApi from '@/api/network';

import switcher from '@/services/switcher';

import CollapsePanel from '@/components/CollapsePanel.vue';
import Pagination from '@/components/Pagination.vue';
import ChildObject from '@/components/Layout/ChildObject.vue';
import CollapseActionMenu from '@/components/CollapseActionMenu.vue';
import CollapseActionMenuItem from '@/components/CollapseActionMenuItem.vue';

export default {
  name: 'NetworkChildren',
  components: {
    CollapseActionMenuItem,
    CollapseActionMenu,
    ChildObject,
    CollapsePanel,
    Pagination,
  },
  computed: {
    ...mapGetters({
      mapObjectCategories: 'settings/getMapObjectCategories',
      mapObjectTypes: 'settings/getMapObjectTypes',
    }),
    mapObjectTypesOnNetwork() {
      if (this.mapObjectTypes === null || this.mapObjectTypes === undefined) {
        return [];
      }
      if (Object.values(this.mapObjectTypes).length === 0) {
        return [];
      }
      return Object.values(this.mapObjectTypes).filter(item => item.on_network);
    },
    formatTypesWithHeaderAsMenuItems() {
      const data = this.groupBy(this.mapObjectTypesOnNetwork, 'map_object_category_id');
      const items = [];
      data.forEach((types, categoryId) => {
        const category = this.mapObjectCategories[categoryId];
        items.push({
          key: categoryId,
          title: category.name,
          icon: null,
          clickable: false,
        });
        types.forEach((type) => {
          items.push({
            key: type.id,
            title: type.name,
            icon: 'plus',
            clickable: true,
          });
        });
      });
      return items;
    },
  },
  data() {
    return {
      showCollapseMenu: false,
      networkId: parseInt(switcher.getSelectedNetworkId(), 10),
      loading: false,
      children: [],
      pagination: {
        total: 0,
        count: 0,
        per_page: 1,
        current_page: 1,
        total_pages: 1,
      },
      current_page: 1,
    };
  },
  methods: {
    toggleShowCollapseMenu() {
      this.showCollapseMenu = !this.showCollapseMenu;
    },
    switchPage(page) {
      this.current_page = page;
      this.getChildren();
    },
    toCreateMapObject(typeId) {
      this.$router.push({ name: 'drawing.create', params: { type: typeId } });
    },
    goToObject(mapObject) {
      EventBus.$emit('Map.zoomToMapObject', mapObject);
      this.$router.push({ name: 'drawing.show', params: { id: mapObject.id } });
    },
    getChildren() {
      const include = 'mapObjectLabel,mapObjectType,children,children.mapObjectLabel,children.mapObjectType';
      this.loading = true;
      NetworkApi.getChildrenForNetwork(this.networkId, include, false, 15, this.current_page)
        .then((response) => {
          this.children = response.data;
          this.pagination = response.meta.pagination;
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getChildren();
  },
  watch: {
    networkId() {
      this.getChildren();
    },
  },
};
</script>
<style scoped>
  div.map-objects-list {
    margin: -15px 0 0 0;
  }
</style>
